export const FIND_MODULE_FAILURE = 'FIND_MODULE_FAILURE';

export const findModuleFailure = error => ({
    type: FIND_MODULE_FAILURE,
    payload: error,
    error: true,
});
